import { Chip } from '@pets-ui/Chip/Chip'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useTranslation } from 'react-i18next'

export const LoginPromotionTip = () => {
  const { t } = useTranslation()
  const renderTranslation = () => {
    return t('login.promotionTipPoints', { defaultValue: '登入後可獲得優惠折扣、累積消費點數、會員專屬優惠！' })
  }
  const renderTip = () => {
    return (
      <Text variant="caption" noWrap={false} color={colors.grey700}>
        {renderTranslation()}
      </Text>
    )
  }
  return (
    <HStack
      flexWrap="nowrap"
      alignItems="center"
      display="flex"
      gap={1}
      mt={4}
      mb={5}
    >
      <Chip size="small" color="red" variant="square">
        {t('login.memberBenefits', { defaultValue: '會員好康' })}
      </Chip>
      {renderTip()}
    </HStack>
  )
}
